import { classNames } from '@/util/tailwindHelpers'
import { INVENTORY_SELECTION_MODE_PARAM } from '../../types'
import { SelectionModeOption } from './SelectionModeOption'
import useUpdateInventoryQuery from '@/hooks/useUpdateInventoryQuery'
import { useArcade } from '@/features/arcade/provider'
import { Icons } from '@/components/Icon'
import { getEntries } from '@/util/objectHelpers'
import Link from 'next/link'
import { SelectionModalDisabledMessage } from './types'

type SelectionModeType = 'transfer' | 'convert'

type SelectionMode = {
  label: string
  icon: Icons
  className: string
  disabled?: boolean
  disabledMessage?: SelectionModalDisabledMessage
}

const SelectionModes: Record<SelectionModeType, SelectionMode> = {
  transfer: {
    label: 'Transfer',
    icon: 'transfer',
    className:
      'has-[:checked]:bg-white has-[:checked]:text-gray-900 has-[:checked:not(:disabled)]:hover:bg-gray-100'
  },
  convert: {
    label: 'Arcade Mode',
    icon: 'joystick',
    className:
      'has-[:checked:not(:disabled)]:shadow-arcade-sm has-[:checked:not(:disabled)]:hover:bg-gray-850 has-[:checked]:text-arcadeGreen has-[:checked]:bg-[#152911] has-[:checked]:border-arcadeGreen',
    disabledMessage: {
      title: 'Season Starting Soon',
      message: (
        <p>
          Arcade mode is disabled until the next season begins. Find out when{' '}
          <Link
            href="/arcade"
            className="inline-link"
            target="_blank"
            rel="noreferrer"
          >
            here
          </Link>
          .
        </p>
      )
    }
  }
}

export const AssetSelectionModes = ({
  layout = 'lg'
}: {
  layout?: 'sm' | 'lg'
}) => {
  const { update } = useUpdateInventoryQuery()
  const { season } = useArcade()

  SelectionModes.convert.disabled = !season.isCurrentSeason
  const options = getEntries(SelectionModes)

  const handleOnClick = (type: SelectionModeType) => {
    update({
      type: 'parameter',
      parameter: INVENTORY_SELECTION_MODE_PARAM,
      value: type,
      action: 'apply'
    })
  }

  return (
    <>
      {options.map(([key, { label, className, ...rest }]) => (
        <SelectionModeOption
          className={classNames(
            {
              'rounded-full': layout === 'sm'
            },
            className
          )}
          title={label}
          theme={key === 'convert' ? 'green-arcade-secondary' : 'white'}
          key={key}
          onClick={() => handleOnClick(key)}
          {...rest}
        />
      ))}
    </>
  )
}
